var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03647 2.49748C2.15992 2.11643 2.56023 1.9105 2.93059 2.03752L4.84624 2.69449C5.65075 2.97039 6.24988 3.66866 6.41619 4.5242L6.49104 4.90925H20.3498C21.4229 4.90925 22.2102 5.94675 21.9499 7.01777L20.7147 12.1014C20.4262 13.2885 19.3895 14.1213 18.2002 14.1213H8.28178L8.56361 15.5711C8.67375 16.1376 9.15726 16.5455 9.71885 16.5455H17.787C18.1774 16.5455 18.4938 16.8711 18.4938 17.2727C18.4938 17.6744 18.1774 18 17.787 18H9.71885C8.48336 18 7.41962 17.1028 7.17732 15.8563L5.0299 4.80946C4.96308 4.46575 4.72239 4.18522 4.39918 4.07437L2.48353 3.4174C2.11317 3.29039 1.91301 2.87853 2.03647 2.49748ZM10.5 9.75H16.5C16.9142 9.75 17.25 9.41421 17.25 9C17.25 8.58579 16.9142 8.25 16.5 8.25H10.5C10.0858 8.25 9.75 8.58579 9.75 9C9.75 9.41421 10.0858 9.75 10.5 9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 19.6716 8.67157 19 9.5 19C10.3284 19 11 19.6716 11 20.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5C18 21.3284 17.3284 22 16.5 22C15.6716 22 15 21.3284 15 20.5C15 19.6716 15.6716 19 16.5 19C17.3284 19 18 19.6716 18 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCart);
export default __webpack_public_path__ + "static/media/remove-cart.046d55099073b033b580ddc1b210adda.svg";
export { ForwardRef as ReactComponent };